// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_f-0";
export var skeletonCard = "_f-1";